import React, { useContext, useEffect, useState } from "react";
import classes from "./Test.module.scss";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import Spinner from "../../../../components/Spinner";
import { MAP_JSON_TEST } from "../../../../constants/tests";
import { get2ndPath } from "../../../../helpers";
import * as iTest from "../../../../interfaces/InterfacesTest";
import TestExamples from "../../../../components/Tests/TestExamples";
import TestResults from "../../../../components/Tests/TestResults";
import TestArea from "../../../../components/Tests/TestArea";
import TestVolume from "../../../../components/Tests/TestVolume";
import { GlobalStateContext } from "../../../../components/Tests/TestsContext/GlobalStateContext";
import useFetch from "../../../../hooks/useFetch";
import { API_TESTS_POST, API_USER_SMART } from "../../../../constants/api";
import SessionContext, {
  SessionInterface,
} from "../../../../context/sessionContext";
import { R_U_TESTS, R_U_ROOT } from "../../../../constants/routes";

const STAGE_LOADING = 0;
const STAGE_TEST_AUDIO = 1;
const STAGE_EXAMPLES = 2;
const STAGE_TEST = 3;
const STAGE_RESULTS = 4;
// const STAGE_END_JOURNEY = 5;

interface dataForBackInterface {
  test_id: string | null;
  respTests: number | null;
  test_name: string;
  score: number;
  test_time: string;
  miscellaneous?: Record<string, any>;
}

export default function Test() {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useNavigate();
  const activeTest: string = get2ndPath(location.pathname) ?? "not-found";
  let testId: string | null = null;

  let zeroMS = 0;
  let twosMS = 0;
  let fivesMS = 0;
  let eigthsMS = 0;
  let tensMS = 0;
  let fifteensMS = 0;

  //prevent user in a done test
  const [respTests, , , getSmartUserFetch]: any = useFetch({
    autoInit: false,
  });
  let testsDone = [];
  if (testsDone.length === 0 && respTests)
    testsDone = respTests.activities_tests;
  const relat = new URL(window.location.href);
  if (testsDone?.length > 0)
    testsDone?.map((item: any) => {
      if (item?.test_name === relat?.href.split("/")[4]) {
        history("/testes");
      }
    });
  const getUser = async (c: any) => {
    const { user } = await c;
    return user;
  };

  const getUserSmartInfo = async () => {
    try {
      const user = await getUser(cSession);
      if (user && user.token) {
        getSmartUserFetch({
          method: "GET",
          url: API_USER_SMART,
          noAuth: true,
          header: {
            userauthorization: user.token,
          },
          onSuccess: () => { },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserSmartInfo();
  }, []);

  const [volume, setVolume] = useState(100 as number);
  const [activeStage, setActiveStage] = useState(STAGE_LOADING);
  const [testData, setTestData] = useState(
    null as iTest.InterfacesTest | boolean | null
  );
  const [resultsEnd, setResultsEnd] = useState([] as any);
  const [scoreAndTime, setScoreLevel] = useState([] as any);
  const [testTime, setTestTime] = useState([] as any);
  const [testLevel, setTestLevelFinal] = useState([] as any);
  const [score, setScore] = useState(0);
  const [testTimeGlobal, setTestTimeGlobal] = useState("");
  const [arrayAnswers, setArrayAnswers] = useState({});
  const [arrayCorrects, setArrayCorrects] = useState({});
  const [arrayMiscellaneousCount, setMiscellaneousCount] = useState({});
  const [globalMiscellaneous, setGlobalMiscellaneous] = useState({
    isRT: null as boolean | null,
    isOT: null as boolean | null,
    isSSW: null as boolean | null,
    zero: 0 as number,
    two: 0 as number,
    five: 0 as number,
    eight: 0 as number,
    ten: 0 as number,
    fifteen: 0 as number,
    oe: 0 as number,
    od: 0 as number,
    sswOE: 0 as number,
    sswOD: 0 as number,
    sswOEComp: 0 as number,
    sswODComp: 0 as number,
  });

  const [timeToPass, setTimeToPass] = useState("");
  const cSession: SessionInterface = useContext(SessionContext);
  if (timeToPass || scoreAndTime) {
    // TODO console.log(timeToPass)
  }
  const setTimer = (stage: number) => {
    const t = Date.now();
    if (stage === 3) {
      setTestTime(t);
    } else if (stage === 4) {
      setTestTime(t - testTime);
    }
  };

  const setMiscellaneousLocal = () => {
    if (String(activeTest) === "resolucao_temporal") {
      globalMiscellaneous.isRT = true;
      if (arrayMiscellaneousCount)
        Object.values(arrayMiscellaneousCount).map((item) => {
          if (item === "0") zeroMS++;
          if (item === "2") twosMS++;
          if (item === "5") fivesMS++;
          if (item === "8") eigthsMS++;
          if (item === "10") tensMS++;
          if (item === "15") fifteensMS++;
        });
      globalMiscellaneous.zero = Object.values(arrayMiscellaneousCount).filter(
        (value) => value === "0"
      ).length;
      globalMiscellaneous.two = Object.values(arrayMiscellaneousCount).filter(
        (value) => value === "2"
      ).length;
      globalMiscellaneous.five = Object.values(arrayMiscellaneousCount).filter(
        (value) => value === "5"
      ).length;
      globalMiscellaneous.eight = Object.values(arrayMiscellaneousCount).filter(
        (value) => value === "8"
      ).length;
      globalMiscellaneous.ten = Object.values(arrayMiscellaneousCount).filter(
        (value) => value === "10"
      ).length;
      globalMiscellaneous.fifteen = Object.values(
        arrayMiscellaneousCount
      ).filter((value) => value === "15").length;
      const { zero, two, five, eight, ten, fifteen } = globalMiscellaneous;
      miscellaneous = {
        zero: zero,
        two: two,
        five: five,
        eight: eight,
        ten: ten,
        fifteen: fifteen,
      };
    } else if (String(activeTest) === "ordenacao_temporal") {
      globalMiscellaneous.isOT = true;
      globalMiscellaneous.oe = Object.values(arrayMiscellaneousCount).filter(
        (value) => value === "oe"
      ).length;
      globalMiscellaneous.od = Object.values(arrayMiscellaneousCount).filter(
        (value) => value === "od"
      ).length;
      const { oe, od } = globalMiscellaneous;
      miscellaneous = { oe: oe, od: od };
    } else if (String(activeTest) === "dicotico_sequencial") {
      globalMiscellaneous.isSSW = true;
      globalMiscellaneous.sswOD = Object.values(arrayMiscellaneousCount).filter(
        (value: any) => {
          return value <= 10 && value > 0;
        }
      ).length;
      globalMiscellaneous.sswOE = Object.values(arrayMiscellaneousCount).filter(
        (value: any) => {
          return value > 30;
        }
      ).length;
      globalMiscellaneous.sswODComp = Object.values(
        arrayMiscellaneousCount
      ).filter((value: any) => {
        return value > 10 && value <= 20;
      }).length;
      globalMiscellaneous.sswOEComp = Object.values(
        arrayMiscellaneousCount
      ).filter((value: any) => {
        return value > 20 && value <= 30;
      }).length;
    }
    return miscellaneous;
  };
  //setScore with contScore for dicotico_sequencial
  let contScore = 0;
  contScore =
    globalMiscellaneous.zero +
    globalMiscellaneous.two +
    globalMiscellaneous.five +
    globalMiscellaneous.eight +
    globalMiscellaneous.ten +
    globalMiscellaneous.fifteen +
    globalMiscellaneous.oe +
    globalMiscellaneous.od +
    globalMiscellaneous.sswOD +
    globalMiscellaneous.sswOE +
    globalMiscellaneous.sswODComp +
    globalMiscellaneous.sswOEComp;

  useEffect(() => {
    setMiscellaneousLocal();
  }, [arrayMiscellaneousCount]);
  useEffect(() => {
    setTimer(activeStage);
    if (activeStage === 4) {
      verificar();
    }
  }, [activeStage]);

  useEffect(() => {
    if (MAP_JSON_TEST && MAP_JSON_TEST[activeTest]) {
      let testFromMap = null;
      try {
        testFromMap = MAP_JSON_TEST[activeTest];
        setActiveStage(STAGE_TEST_AUDIO);
        setTestData(testFromMap);
        if (testFromMap) testId = MAP_JSON_TEST[activeTest].test_id;
      } catch (error) {
        console.error("[error]", error);
      }
    }
  }, [activeTest]);

  const verificar = () => {
    setScore(contScore);
  };

  const confirmWithoutSave = () => {
    return history(R_U_TESTS);
  };
  const confirmSave = () => {
    sentDataEndpoint(dataForBack);
  };
  let _content = null;
  let _title = t("global.test");
  let _subtitle = "";
  let _label = null as string | null;
  let _subLabel = null as string | null;
  _content = <Spinner center />;
  if (testData && typeof testData === "object") {
    const { examples = null } = testData ?? {};
    const { list_examples = null } = examples ?? {};
    switch (activeStage) {
      case STAGE_LOADING:
        break;
      case STAGE_TEST_AUDIO: {
        _title += " - " + t("tests." + activeTest);
        _title += " - " + t("global.adjusts");
        _subtitle = t("global.verify_your_volume_before_starting_tests");
        let audioFile = null;
        if (list_examples && list_examples[0] && list_examples[0].audio) {
          audioFile = list_examples[0].audio;
        }
        _content = (
          <TestVolume
            audioFile={audioFile}
            volume={volume}
            activeTest={activeTest}
            setVolume={setVolume}
            onClick={() => setActiveStage(activeStage + 1)}
          />
        );
        _label = t("global.adjust_mode");
        _subLabel = t("global.you_will_not_be_rated_on_this_mode");
        break;
      }
      case STAGE_EXAMPLES:
        _title += " - " + t("tests." + activeTest);
        _title += " - " + t("global.examples");
        _subtitle = t("global.test_mode");
        _content = (
          <TestExamples
            examples={examples}
            volume={volume}
            activeTest={activeTest}
            onClick={() => setActiveStage(activeStage + 1)}
          />
        );
        _label = t("global.test_mode");
        _subLabel = t("global.you_will_not_be_rated_on_this_mode");
        break;
      case STAGE_TEST:
        _title += " - " + t("tests." + activeTest);
        _content = (
          <TestArea
            test={testData}
            volume={volume}
            testTime={testTime}
            activeTest={activeTest}
            setResultsGrandfather={setResultsEnd}
            setScoreLevel={setScoreLevel}
            setTestLevelFinal={setTestLevelFinal}
            onClick={() => setActiveStage(activeStage + 1)}
          />
        );
        break;
      case STAGE_RESULTS:
        _title += " - " + t("tests." + activeTest);
        _title += " - " + t("global.results");
        _subtitle = t("global.results_subtitle");
        _content = (
          <TestResults
            testTime={testTime}
            results={
              String(activeTest) === "resolucao_temporal" ||
                String(activeTest) === "ordenacao_temporal" ||
                String(activeTest) === "dicotico_sequencial"
                ? score
                : resultsEnd
            }
            testLevel={testLevel}
            onClick={() => {
              confirmSave();
            }}
            onClickWS={() => {
              confirmWithoutSave();
            }}
            setTimeToPass={setTimeToPass}
          />
        );
        break;
      default:
        // ERROR MSG
        break;
    }
  }
  if (MAP_JSON_TEST[activeTest]) testId = MAP_JSON_TEST[activeTest].test_id;
  let scoreMiscellaneous = null;
  let miscellaneous = {};
  if (globalMiscellaneous) scoreMiscellaneous = setMiscellaneousLocal();
  let scoreData = 0;
  if (String(activeTest) === "ordenacao_temporal") {
    scoreData = score;
  } else if (String(activeTest) === "resolucao_temporal") {
    scoreData = score / 5;
  } else if (String(activeTest) === "dicotico_sequencial") {
    scoreData = score / 4;
  } else {
    scoreData = resultsEnd;
  }
  const dataForBack: dataForBackInterface = {
    test_id: testId,
    respTests: respTests?.journey,
    score: scoreData,
    test_name: activeTest,
    test_time: testTimeGlobal,
    miscellaneous: {
      answers: arrayAnswers,
      score: setMiscellaneousLocal(),
    },
  };

  const [, , , sendData]: any = useFetch({
    autoInit: false,
  });
  const sentDataEndpoint = async (data: any) => {
    const token = cSession.user?.token;
    try {
      sendData({
        url: API_TESTS_POST,
        method: "POST",
        noAuth: true,
        data: data,
        header: {
          userauthorization: token,
        },
        onSuccess: () => {
          getUserSmartInfo();
          if (respTests?.activities_tests?.length !== 10) {
            history(R_U_TESTS);
          } else {
            if (respTests?.activities_tests?.length === 10)
              cSession.setPublicSmartUser(
                {
                  ...cSession.user,
                  journey_code: 1
                },
                token
              ); else if (respTests?.activities_tests?.length === 20)
              cSession.setPublicSmartUser(
                {
                  ...cSession.user,
                  journey_code: 3
                },
                token
              )
            history(R_U_ROOT);
          }
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <GlobalStateContext.Provider
        value={{
          score,
          setScore,
          testTimeGlobal,
          setTestTimeGlobal,
          arrayAnswers,
          setArrayAnswers,
          arrayCorrects,
          setArrayCorrects,
          arrayMiscellaneousCount,
          setMiscellaneousCount,
          globalMiscellaneous,
          setGlobalMiscellaneous,
        }}
      >
        <PageHeader title={_title} subtitle={_subtitle} />
        <PageMain centerStretch className={classes.TestArea}>
          {_content}
        </PageMain>
        {_label && (
          <div className={classes.BottomLabel}>
            <div className={classes.InfoArea}>
              <p>
                <strong>{_label}</strong>
              </p>
              <p>{_subLabel}</p>
            </div>
          </div>
        )}
      </GlobalStateContext.Provider>
    </>
  );
}
